import './add-field.less';
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classname';

const propTypes = {
	intl: PropTypes.func,
	disabled: PropTypes.bool,
	onClick: PropTypes.func
};

const AddField = ({
	intl,
	disabled,
	onClick
}) => (
	<div
		className={cn('add-entity', disabled && 'add-entity--disabled')}
		onClick={() => { !disabled && onClick(); }}
	>
		<span className="title">{intl(!disabled ? 'Add offer' : 'Select offers')}</span>
	</div>
);

AddField.propTypes = propTypes;

export default AddField;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates/components/profile/forms/individual-terms/add-field.js